export const BOX_LONG_UNITS = 4.5;
const DEFAULT_LONGEST_DIM_CM = 40;

// Normalizes dimensions to landscape orientation (wider side as width).
// Variants are only stored portrait-first (e.g. "10 x 15"), so the preview
// defaults to landscape; the "Otočiť" button flips to portrait.
export function toLandscape({ w, h }) {
  return w >= h ? { w, h } : { w: h, h: w };
}

export function computeBoxDimensions({ dimW, dimH }) {
  if (dimW >= dimH) {
    return { w: BOX_LONG_UNITS, h: BOX_LONG_UNITS * (dimH / dimW) };
  }
  return { w: BOX_LONG_UNITS * (dimW / dimH), h: BOX_LONG_UNITS };
}

export function computeDepthFromCm({ thicknessCm, longestDimCm }) {
  const longest = longestDimCm || DEFAULT_LONGEST_DIM_CM;
  return (thicknessCm / longest) * BOX_LONG_UNITS;
}

// Returns an array of 5 UV coord sets (front face + 4 sides), each as 4 [u, v] pairs.
// Order matches BoxGeometry material indices [+X, -X, +Y, -Y, +Z]; back face (-Z, index 5)
// is the caller's concern.
export function computeSideUvs({ mirrored, w, h, d }) {
  const sliceX = d / w;
  const sliceY = d / h;

  if (mirrored) {
    return [
      [[1, 1], [1 + sliceX, 1], [1, 0], [1 + sliceX, 0]],
      [[-sliceX, 1], [0, 1], [-sliceX, 0], [0, 0]],
      [[0, 1 + sliceY], [1, 1 + sliceY], [0, 1], [1, 1]],
      [[0, 0], [1, 0], [0, -sliceY], [1, -sliceY]],
      [[0, 1], [1, 1], [0, 0], [1, 0]]
    ];
  }
  return [
    [[1 - sliceX, 1], [1, 1], [1 - sliceX, 0], [1, 0]],
    [[0, 1], [sliceX, 1], [0, 0], [sliceX, 0]],
    [[0, 1], [1, 1], [0, 1 - sliceY], [1, 1 - sliceY]],
    [[0, sliceY], [1, sliceY], [0, 0], [1, 0]],
    [[sliceX, 1 - sliceY], [1 - sliceX, 1 - sliceY], [sliceX, sliceY], [1 - sliceX, sliceY]]
  ];
}
